import type { CategoriaDocumento } from '../types';
import { CATEGORIAS_DOCUMENTO } from '../types';

export function formatarTamanho(bytes: number): string {
  if (!bytes || bytes === 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatarData(data?: string | null): string {
  if (!data) return '—';
  try {
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
    });
  } catch {
    return data;
  }
}

export function labelCategoria(cat: CategoriaDocumento | string): string {
  return CATEGORIAS_DOCUMENTO.find(c => c.value === cat)?.label || cat;
}
